import React, { useEffect } from 'react';
import '../AboutStyles/PurposeValuesSection.css';

const cards = [
  {
    icon: 'bi-bullseye',
    title: 'Purpose',
    color: '#0066cc',
    points: [
      'Innovate to empower businesses through technology',
      'Deliver measurable impact to every client we serve',
      'Bridge the gap between complexity and simplicity',
    ],
  },
  {
    icon: 'bi-eye',
    title: 'Vision',
    color: '#0052a3',
    points: [
      'Become the most trusted IT partner globally',
      'Shape the future of digital transformation',
      'Enable sustainable growth for all stakeholders',
    ],
  },
  {
    icon: 'bi-gem',
    title: 'Values',
    color: '#003d7a',
    points: [
      'Integrity in every decision and interaction',
      'Excellence as our non-negotiable standard',
      'Collaboration that drives collective success',
    ],
  },
];

const VisionValueSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.pvs-card').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="pvs-section">
      <div className="pvs-wrapper">
        <p className="pvs-description">
          Bellary Info Tech Solutions purpose is enshrined in our values and reflected in the
          mindfulness we bring to using technology and solving business problems. Purpose guides our
          actions; it shapes strategy and provides predictability to execution; it is the foundation
          for service excellence. Our clients partner with us for what we do — and as much for why we
          do it.
        </p>

        <div className="pvs-grid">
          {cards.map((card, index) => (
            <div key={index} className="pvs-card">
              <div className="pvs-icon-wrap" style={{ background: card.color }}>
                <i className={`bi ${card.icon}`}></i>
              </div>
              <h2 className="pvs-card-title">{card.title}</h2>
              <ul className="pvs-card-points">
                {card.points.map((point, pi) => (
                  <li key={pi}>
                    <span className="pvs-bullet">
                      <i className="bi bi-check-circle-fill"></i>
                    </span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VisionValueSection;
